// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let Form__Label = require("../common/Components/Form__Label.bs.js");
let Form__Radio = require("../common/Components/Form__Radio.bs.js");
let Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
let SystemMessage = require("../common/Components/SystemMessage.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let SettingsPageHeader = require("./SettingsPageHeader.bs.js");
let UserViewPreferences = require("../common/UserViewPreferences.bs.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let FormalityCompat__PublicHelpers = require("@tan/formality/src/FormalityCompat__PublicHelpers.bs.js");
let ViewPreferencesForm_preferences_graphql = require("../../__generated__/ViewPreferencesForm_preferences_graphql.bs.js");

let convertFragment = ViewPreferencesForm_preferences_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ViewPreferencesForm_preferences_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ViewPreferencesForm_preferences_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ViewPreferencesForm_preferences_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ViewPreferencesForm_preferences_graphql.node, convertFragment, fRef);
}

let Fragment_defaultView_decode = ViewPreferencesForm_preferences_graphql.Utils.defaultView_decode;

let Fragment_defaultView_fromString = ViewPreferencesForm_preferences_graphql.Utils.defaultView_fromString;

let Fragment = {
  defaultView_decode: Fragment_defaultView_decode,
  defaultView_fromString: Fragment_defaultView_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let validators = {
  desktopDefaultView: undefined,
  mobileDefaultView: undefined
};

function initialFieldsStatuses(input) {
  return {
    desktopDefaultView: "Pristine",
    mobileDefaultView: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    desktopDefaultView: "Pristine",
    mobileDefaultView: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      desktopDefaultView: "Pristine",
      mobileDefaultView: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, param, param$1) {
  let match_0 = {
    TAG: "Ok",
    _0: input.desktopDefaultView
  };
  let match_0$1 = {
    TAG: "Ok",
    _0: input.mobileDefaultView
  };
  let desktopDefaultViewResult = match_0;
  let desktopDefaultViewResult$1;
  if (desktopDefaultViewResult.TAG === "Ok") {
    let mobileDefaultViewResult = match_0$1;
    if (mobileDefaultViewResult.TAG === "Ok") {
      return {
        TAG: "Valid",
        output: {
          desktopDefaultView: desktopDefaultViewResult._0,
          mobileDefaultView: mobileDefaultViewResult._0
        },
        fieldsStatuses: {
          desktopDefaultView: {
            TAG: "Dirty",
            _0: desktopDefaultViewResult,
            _1: "Hidden"
          },
          mobileDefaultView: {
            TAG: "Dirty",
            _0: mobileDefaultViewResult,
            _1: "Hidden"
          }
        },
        collectionsStatuses: undefined
      };
    }
    desktopDefaultViewResult$1 = desktopDefaultViewResult;
  } else {
    desktopDefaultViewResult$1 = desktopDefaultViewResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      desktopDefaultView: {
        TAG: "Dirty",
        _0: desktopDefaultViewResult$1,
        _1: "Hidden"
      },
      mobileDefaultView: {
        TAG: "Dirty",
        _0: match_0$1,
        _1: "Hidden"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurDesktopDefaultViewField" :
          let result = Formality.validateFieldOnBlurWithoutValidator(state.input.desktopDefaultView, state.fieldsStatuses.desktopDefaultView, status => {
            let init = state.fieldsStatuses;
            return {
              desktopDefaultView: status,
              mobileDefaultView: init.mobileDefaultView
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurMobileDefaultViewField" :
          let result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.mobileDefaultView, state.fieldsStatuses.mobileDefaultView, status => {
            let init = state.fieldsStatuses;
            return {
              desktopDefaultView: init.desktopDefaultView,
              mobileDefaultView: status
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateDesktopDefaultViewField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.desktopDefaultView, status => {
                let init = state.fieldsStatuses;
                return {
                  desktopDefaultView: status,
                  mobileDefaultView: init.mobileDefaultView
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateMobileDefaultViewField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.mobileDefaultView, status => {
                let init = state.fieldsStatuses;
                return {
                  desktopDefaultView: init.desktopDefaultView,
                  mobileDefaultView: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  desktopDefaultView: "Pristine",
                  mobileDefaultView: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  desktopDefaultView: "Pristine",
                  mobileDefaultView: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: map(error$2)
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateDesktopDefaultView: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateDesktopDefaultViewField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateMobileDefaultView: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateMobileDefaultViewField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurDesktopDefaultView: () => dispatch("BlurDesktopDefaultViewField"),
    blurMobileDefaultView: () => dispatch("BlurMobileDefaultViewField"),
    desktopDefaultViewResult: Formality.exposeFieldResult(state.fieldsStatuses.desktopDefaultView),
    mobileDefaultViewResult: Formality.exposeFieldResult(state.fieldsStatuses.mobileDefaultView),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.desktopDefaultView;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.mobileDefaultView;
      return typeof tmp$1 === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function ViewPreferencesForm$ViewInput(props) {
  let label = props.label;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: label
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Radio.RadioList.make, {
          selected: props.selected,
          items: [
            {
              label: "Map",
              value: "MAP"
            },
            {
              label: "List",
              value: "LIST"
            }
          ],
          name: props.name,
          ariaLabel: label,
          toValue: value => value,
          onChange: props.onChange,
          layout: "Horizontal"
        }),
        className: "sm:col-span-2"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
  });
}

let ViewInput = {
  make: ViewPreferencesForm$ViewInput
};

function toInput(fallback, view) {
  if (view === "LIST" || view === "MAP") {
    if (view === "LIST") {
      return "LIST";
    } else {
      return "MAP";
    }
  } else {
    return fallback;
  }
}

function ViewPreferencesForm(props) {
  let preferences = RescriptRelay_Fragment.useFragment(ViewPreferencesForm_preferences_graphql.node, convertFragment, props.preferences);
  let match = UserViewPreferences.Mutation.use();
  let isUpdating = match[1];
  let updatePreferences = match[0];
  let form = useForm({
    desktopDefaultView: toInput("MAP", preferences.desktopDefaultView),
    mobileDefaultView: toInput("LIST", preferences.mobileDefaultView)
  }, (input, param) => {
    let notifyOnFailure = param.notifyOnFailure;
    let notifyOnSuccess = param.notifyOnSuccess;
    updatePreferences({
      input: {
        desktopDefaultView: input.desktopDefaultView,
        mobileDefaultView: input.mobileDefaultView
      }
    }, undefined, undefined, undefined, (param, errors) => {
      if (param.updateUserViewPreferences !== undefined && errors === undefined) {
        return notifyOnSuccess(undefined);
      } else {
        return notifyOnFailure("We couldn't save your preferences. Please try again.");
      }
    }, param => notifyOnFailure("We couldn't save your preferences. Please try again."), undefined);
  });
  let message = form.status;
  let tmp;
  tmp = typeof message !== "object" ? (
      message === "Editing" ? null : JsxRuntime.jsx(SystemMessage.make, {
          id: "view-preferences-saved",
          time: 5000,
          text: "Preferences saved",
          type_: "success",
          dismissible: true,
          secondary: true,
          handleOnDismiss: param => form.dismissSubmissionResult()
        })
    ) : (
      message.TAG === "Submitting" ? null : JsxRuntime.jsx(SystemMessage.make, {
          id: "view-preferences-save-error",
          time: 5000,
          text: message._0,
          type_: "error",
          dismissible: true,
          secondary: true,
          handleOnDismiss: param => form.dismissSubmissionResult()
        })
    );
  return JsxRuntime.jsxs("form", {
    children: [
      JsxRuntime.jsxs("fieldset", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(SettingsPageHeader.SectionHeading.make, {
                    title: "Property search"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Choose the view to open when browsing properties. You can choose a different default for desktop and mobile.",
                    className: "text-base text-zinc-500"
                  })
                ],
                className: "space-y-2"
              }),
              tmp
            ],
            className: "space-y-4 sm:pb-6 sm:pt-3"
          }),
          JsxRuntime.jsx(ViewPreferencesForm$ViewInput, {
            label: "Default desktop view",
            name: "desktopDefaultView",
            selected: form.input.desktopDefaultView,
            onChange: value => form.updateDesktopDefaultView((input, desktopDefaultView) => ({
              desktopDefaultView: desktopDefaultView,
              mobileDefaultView: input.mobileDefaultView
            }), value)
          }),
          JsxRuntime.jsx(ViewPreferencesForm$ViewInput, {
            label: "Default mobile view",
            name: "mobileDefaultView",
            selected: form.input.mobileDefaultView,
            onChange: value => form.updateMobileDefaultView((input, mobileDefaultView) => ({
              desktopDefaultView: input.desktopDefaultView,
              mobileDefaultView: mobileDefaultView
            }), value)
          })
        ],
        className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0",
        disabled: form.submitting || isUpdating
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
          onClick: extra => Form__Helpers.preventDefault(form.submit, extra),
          disabled: form.submitting || isUpdating,
          children: isUpdating ? "Saving…" : "Save"
        })
      })
    ],
    className: "space-y-8",
    onSubmit: extra => FormalityCompat__PublicHelpers.Dom.preventDefault(form.submit, extra)
  });
}

let make = ViewPreferencesForm;

exports.Fragment = Fragment;
exports.FormConfig = FormConfig;
exports.ViewInput = ViewInput;
exports.toInput = toInput;
exports.make = make;
/* react Not a pure module */
